import { cn } from "@/lib/cn";
import { AgentCursor } from "@/workshop/components/cursors/agent-cursor";

/**
 * Workshop: Overlay container rendering multiple agent cursors.
 * Uses absolute positioning with hardcoded coordinates (no React Flow).
 */

interface CursorData {
  id: string;
  name: string;
  color: string;
  x: number;
  y: number;
  toolCall?: string;
  content?: string;
}

interface AgentCursorOverlayProps {
  cursors: CursorData[];
  className?: string;
  "data-testid"?: string;
}

export function AgentCursorOverlay({
  cursors,
  className,
  "data-testid": testId = "agent-cursor-overlay",
}: AgentCursorOverlayProps) {
  if (cursors.length === 0) return null;

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-50 overflow-hidden",
        className,
      )}
      data-testid={testId}
      aria-hidden="true"
    >
      {cursors.map((cursor) => (
        <div
          key={cursor.id}
          className="absolute transition-transform duration-150 ease-out"
          style={{ transform: `translate(${cursor.x}px, ${cursor.y}px)` }}
        >
          <AgentCursor
            agentName={cursor.name}
            agentColor={cursor.color}
            toolCall={cursor.toolCall}
            content={cursor.content}
            statusAppearance="presence"
            className="w-[260px]"
            data-testid={`agent-cursor-${cursor.id}`}
          />
        </div>
      ))}
    </div>
  );
}

export type { AgentCursorOverlayProps, CursorData };
